import * as icons from "../../assets/icons"

const Icon = ({ fill, icon, height, width, ...rest }) => {
    const Component = icons[icon]
    return <Component fill={fill} height={height} width={width} {...rest} />
}

export default Icon
